import angular from 'angular';
import template from './template.html';
import './style.scss';

export class ChooseMode {
    chooseMode = mode => this.onChooseMode({ mode });
}

export const chooseModeConfiguration = {
    template,
    bindings: {
        onChooseMode: '&',
        onClose: '&',
    },
    controller: ChooseMode,
    controllerAs: 'chooseModeCtrl',
};

angular.module('TALENYA-FE').component('chooseMode', chooseModeConfiguration);
